import React from "react";
import {ReactComponent as ClockIconSmall} from "../../../images/state/update_16.svg";
import {ReactComponent as DisactiveIconSmall} from "../../../images/state/do_disturb_16.svg";
import {ReactComponent as ArchiveIconSmall} from "../../../images/state/check_circle_16.svg";
import {ReactComponent as ActiveIconSmall} from "../../../images/state/offline_bolt_16.svg";

export const SmallStateIcon = (stateid, classname) => {
  switch(stateid) {
    case 0:
      return <ClockIconSmall className={classname}/>;
    case 1:
      return <ActiveIconSmall className={classname}/>;
    case 2:
      return <ArchiveIconSmall className={classname}/>;
    case -1:
      return <DisactiveIconSmall className={classname}/>;
    default:
      return <ClockIconSmall className={classname}/>;
  }
};

export const StateTextColor = stateid => {
  switch(stateid) {
    case 0:
      return "#007FBD";
    case 1:
      return "#85C446";
    case 2:
      return "#778899";
    case -1:
      return "#F15454";
    default:
      return "#000000";
  }
};
